"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var degreesToRadians = function degreesToRadians(angleInDegrees) {
  return angleInDegrees * Math.PI / 180.0;
};

var _default = degreesToRadians;
exports["default"] = _default;